import { Component, DoCheck, Input, inject } from '@angular/core';
import { AufnahmePunktDocument, bodenformString, wasserformString, bohrpunktNummerLabel, hatHumusForm, hatVegetationsformengruppe, humusformLabel, isB, isG, isM, istPunktartDrehbar, istPunktartMitKalkSpiegeltiefe, roundToNumber, punktartDisplayLabel, punktartNummerFromLabel } from '../../../data-model';
import { EvaluationService } from '../../evaluation.service';
import { ValidationService } from '../../validation.service';
import { DataService } from 'src/app/data.service';
import { AuthService } from 'src/app/auth.service';
import { angezeigteTiefe, filzVersatz } from '../../filz-tiefen';

@Component({
    standalone: false,
    selector: 'bp-bohrpunkt-kurzprotokoll',
    templateUrl: './bohrpunkt-kurzprotokoll.component.html',
    styleUrls: ['../hl-table.component.css'],

})
export class BohrpunktKurzprotokollComponent implements DoCheck {

  @Input() bp!: AufnahmePunktDocument;
  @Input() printView!: boolean;

	roundToNumber = roundToNumber;
	bohrpunktNummerLabel = bohrpunktNummerLabel
	humusformLabel = humusformLabel;
	hatHumusForm = hatHumusForm;
	hatVegetationsformengruppe = hatVegetationsformengruppe;
	wasserformString = wasserformString;
	istPunktartDrehbar = istPunktartDrehbar;
	istPunktartMitKalkSpiegeltiefe = istPunktartMitKalkSpiegeltiefe;
	aus = inject(AuthService);
  private ds = inject(DataService);
  private es = inject(EvaluationService);
  private vs = inject(ValidationService);

  /** Prüft ob Kartierer/Datum angezeigt werden darf (nicht für Gäste und nicht-angemeldete) */
  canSeePersonalData(): boolean {
    return this.aus.isAuthenticated.getValue() && !this.aus.isGuest();
  }

  /**
   * Punktart-Feld: zeigt das Label "Beschreibung (Nummer)" (Single Source aus der
   * Punktarten-Liste), speichert aber den `type` (reine Nummer) — analog
   * AufnahmeComponent/KurzprotokollComponent. Direkte Bindung an `bp.type` (rohe
   * Nummer) wuerde gegen die Label-Liste als "Wert nicht in der Liste" fehlschlagen.
   */
  get punktartModel(): string {
    return punktartDisplayLabel(this.bp?.type);
  }
  set punktartModel(label: string) {
    const nummer = punktartNummerFromLabel(label);
    if (nummer) this.bp.type = nummer;
  }

  ngDoCheck(): void {
    this.es.setContext(this.bp);
    this.vs.setContext(this.bp);
  }

  /** Pfeilrichtung eines drehbaren Symbols geändert: setzen und sofort speichern. */
  async onRotationChanged(deg: number): Promise<void> {
    this.bp.rotation = deg;
    await this.ds.saveDocument(this.bp);
  }

  adresse(): string {
    const a = this.bp.header.adresse;
    return '${a.abteilung}${a.unterabteilung}${a.teilflaeche}';
  }

  hasGemarkung(): boolean {
    return !!this.bp.header.adresse.gemarkung || !!this.bp.header.adresse.flur || !!this.bp.header.adresse.flurstueck;
  }

  isB(): boolean {
    return isB(this.bp);
  }

  isG(): boolean {
    return isG(this.bp);
  }

  isM(): boolean {
    return isM(this.bp);
  }

  bodenformString(which: string) {
		return bodenformString(this.bp.header.bodenform, which);
  }

  qualityString(quality: number) {
    const e = this.ds.getHardcoded('Qualitätsstufen').find((entry: any) => entry.id === quality);
    return e ? e.name : "unbekannt";
  }

  /**
   * Eine Tiefe, wie sie hier steht: eingegeben ab Mineralboden, bei Filz um die
   * Auflage tiefer (wie im Reiter „Boden"). Für die Spiegeltiefe heisst das:
   * „über Flur" zählt bei Filz ab Oberkante Humusauflage (flur-tiefe.ts).
   */
  tiefe(eingegeben: number | undefined): number | undefined {
    return angezeigteTiefe(eingegeben, filzVersatz(this.bp));
  }

  hauptbodenform = () => this.bodenformString('hbf');
  feinbodenform = () => this.bodenformString('fbf');
  mesoklimaSuffix = () => this.bp.extendedHeader?.mesoklima ? `-${this.bp.extendedHeader.mesoklima}` : '';
}
